"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeUserFromComposition = exports.addUserToComposition = exports.removeToast = exports.addToast = exports.setBodyEditorActive = exports.setEditorLoaded = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

/**
 * This file should be reserved for redux actions pertaining the the global app.
 * For all other actions place them in their corresponding action module or create a new module
 */
var setEditorLoaded = (0, _utils.createAction)(_ActionTypes.default.SET_EDITOR_LOADED);
exports.setEditorLoaded = setEditorLoaded;
var caSetBodyEditorActive = (0, _utils.createAction)(_ActionTypes.default.SET_BODY_EDITOR_ACTIVE);

var setBodyEditorActive = function setBodyEditorActive(active) {
  return function (dispatch) {
    return dispatch(caSetBodyEditorActive(active));
  };
};

exports.setBodyEditorActive = setBodyEditorActive;
var addToast = (0, _utils.createAction)(_ActionTypes.default.ADD_TOAST);
exports.addToast = addToast;
var removeToast = (0, _utils.createAction)(_ActionTypes.default.REMOVE_TOAST);
exports.removeToast = removeToast;

var addUserToComposition = function addUserToComposition(data) {
  return function (dispatch) {
    return dispatch((0, _utils.createAction)(_ActionTypes.default.REALTIME_ADD_USER)(data));
  };
};

exports.addUserToComposition = addUserToComposition;

var removeUserFromComposition = function removeUserFromComposition(data) {
  return function (dispatch) {
    return dispatch((0, _utils.createAction)(_ActionTypes.default.REALTIME_REMOVE_USER)(data));
  };
};

exports.removeUserFromComposition = removeUserFromComposition;